import clsx from 'clsx';
import React from 'react';

interface ErrorDisplayProps {
  errors: string[];
  className?: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ className, errors }) => {
  if (!errors.length) return null;
  return (
    <div className={clsx('mt-2 text-center w-full', className)}>
      {errors.map((err, idx) => (
        <div key={idx} className="text-[#cc4747] text-xs">
          {err}
        </div>
      ))}
    </div>
  );
};
